import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ISuggestion } from '@bca-shared/modules/type-ahead/type-ahead.models';
import { Observable } from 'rxjs';
import { IStation } from '@bca-compose/models/station';

@Component({
  selector: 'bca-choose-station',
  templateUrl: 'choose-station.component.html',
  styleUrls: ['choose-station.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChooseStationComponent implements OnInit, OnChanges {
  @Input()
  label: string;
  @Input()
  stationsLoading: boolean;
  @Input()
  routeLoading: boolean;
  @Input()
  selectedStation: IStation;
  @Input()
  requiredError: boolean;

  @Input()
  searchFn: (searchTerm$: Observable<string>) => Observable<ISuggestion<IStation>[]>;

  @Output()
  selected = new EventEmitter<IStation>();

  searchControl = new FormControl();

  ngOnInit(): void {
    const { searchControl, selectedStation } = this;
    if (!selectedStation) return;
    searchControl.setValue(selectedStation.naam, {
      emitEvent: false
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { searchControl } = this;
    const routeLoading = changes['routeLoading'];
    if (routeLoading && routeLoading.currentValue) {
      searchControl.disable({ emitEvent: false });
    } else {
      searchControl.enable({ emitEvent: false });
    }
  }

  onFocus(event: FocusEvent): void {
    const { searchControl } = this;
    searchControl.reset();
  }

  onFocusOut(event: FocusEvent): void {
    const { selectedStation, searchControl } = this;
    if (!selectedStation) return;
    searchControl.setValue(selectedStation.naam, {
      emitEvent: false
    });
  }
}
